module.exports = __webpack_public_path__ + "img/icon-vk-graph.8693f209.svg";